import { useEffect, useState } from 'react';
import Access from "../Components/Access";
import Navbar from "../Components/Navbar";
import NavbarAdmin from "../Components/NavbarAdmin";
import ModalUpdateUser from "../Components/ModalUpdateUser";
import { escapeHtml, rescueHtml } from '../Components/Tools';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';
import * as XLSX from 'xlsx';


const Organismes = (props) =>
{
    const [aff, setAff] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [userFocus, setUserFocus] = useState(false);
    const [liste, setListe] = useState([]);
    const [listeOriginal, setListeOriginal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [boolID, setBoolID] = useState(true);
    const [boolNom, setBoolNom] = useState(false);
    const [boolSiren, setBoolSiren] = useState(false);
    const [boolCodeGeo, setBoolCodeGeo] = useState(false);
    const [boolType, setBoolType] = useState(false);
    const [boolActive, setBoolActive] = useState(false);
    const [filterNom, setFilterNom] = useState('');
    const [filterSiren, setFilterSiren] = useState('');
    const [filterCodeGeo, setFilterCodeGeo] = useState('');
    const [filterType, setFilterType] = useState('');
    const [filterActive, setFilterActive] = useState('');
    const [typesOrganismes, setTypesOrganismes] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const heightObject = window.innerHeight/1.9;

    const purple = '#6571FE';
    const blue = '#069BD3';

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        }
        else {
            getOrganismes();
            getOrganismesType();
        }
    }, [props.user])


    async function getOrganismes()
    {
        setIsLoading(true);
        axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({'getOrganismes': true}))
        .then((res) => {
            // Convertir active en nombre pour éviter les problèmes de comparaison
            const organizmesWithActiveAsNumber = res.data.map(org => ({
                ...org,
                active: parseInt(org.active)
            }));
            setListe(organizmesWithActiveAsNumber);
            setListeOriginal(organizmesWithActiveAsNumber.map(org => ({...org})));
            setIsLoading(false);
        })
        .catch((err) => {
            console.warn(err)
            setIsLoading(false);
        })
    }

    async function getOrganismesType()
    {
        axios.post("https://app-slfinance.fr/api/organismes_type.php", qs.stringify({'getOrganismesType': true}))
        .then((res) => {
            setTypesOrganismes(res.data);
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    const handleOrganismeChange = (id, field, value) => {
        // Trouver l'organisme actuel
        const currentOrganisme = liste.find(org => org.id === id);
        
        // Comparer la nouvelle valeur avec l'ancienne
        if (currentOrganisme[field] === value) {
            // Les valeurs sont identiques, ne rien faire
            return;
        }
        
        // Les valeurs sont différentes, créer l'organisme mis à jour
        const updatedOrganisme = {...currentOrganisme, [field]: value};
        
        // Mettre à jour la liste
        setListe(liste.map(org => 
            org.id === id ? updatedOrganisme : org
        ));
        
        // Sauvegarder si active ou id_organisme_type
        if (field === 'active' || field === 'id_organisme_type') {
            saveOrganisme(updatedOrganisme);
        }
    };

    const saveOrganisme = async (organisme) => {
        // Vérifier s'il y a eu un changement
        const original = listeOriginal.find(org => org.id === organisme.id);
        
        if (!original) return;
        
        const hasChanged = 
            original.nom !== organisme.nom ||
            original.siren !== organisme.siren ||
            original.code_geo !== organisme.code_geo ||
            original.id_organisme_type !== organisme.id_organisme_type ||
            original.active !== organisme.active;
        
        // Ne pas sauvegarder s'il n'y a pas de changement
        if (!hasChanged) {
            return;
        }
        
        try {
            const response = await axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({
                'updateOrganisme': true,
                'id': organisme.id,
                'nom': escapeHtml(organisme.nom),
                'siren': organisme.siren,
                'code_geo': organisme.code_geo,
                'id_organisme_type': organisme.id_organisme_type,
                'active': organisme.active
            }));
            
            if(response.data.status === 1) {
                NotificationManager.success(response.data.status_message);
                // Mettre à jour la version originale aussi
                setListeOriginal(listeOriginal.map(org => 
                    org.id === organisme.id ? {...organisme} : org
                ));
            } else {
                NotificationManager.error(response.data.status_message);
                getOrganismes();
            }
        } catch(err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de la sauvegarde');
            getOrganismes();
        }
    };

    const getListeFiltered = () => {
        return liste.filter(organisme => {
            const nomMatch = organisme.nom.toLowerCase().includes(filterNom.toLowerCase());
            const sirenMatch = filterSiren === '' || organisme.siren.toString().includes(filterSiren);
            const codeGeoMatch = filterCodeGeo === '' || organisme.code_geo.toLowerCase().includes(filterCodeGeo.toLowerCase());
            const typeMatch = filterType === '' || organisme.id_organisme_type.toString() === filterType;
            const activeMatch = filterActive === '' || organisme.active.toString() === filterActive;
            
            return nomMatch && sirenMatch && codeGeoMatch && typeMatch && activeMatch;
        });
    };

    const downloadCSV = () => {
        const filteredData = getListeFiltered();
        const headers = ['Active', 'ID', 'Nom Organisme', 'SIREN', 'Code Géo', 'Type Organisme'];
        
        const getTypeLabel = (typeId) => {
            const type = typesOrganismes.find(t => t.id == typeId);
            return type ? type.nom_categorie : typeId;
        };

        let csvContent = headers.join(',') + '\n';
        
        filteredData.forEach(organisme => {
            const row = [
                organisme.active === 1 ? 'Oui' : 'Non',
                organisme.id,
                `"${organisme.nom}"`,
                organisme.siren,
                organisme.code_geo,
                getTypeLabel(organisme.id_organisme_type)
            ];
            csvContent += row.join(',') + '\n';
        });

        // Construire le nom du fichier avec les filtres
        let filename = 'organismes';
        if (filterNom) filename += '_nom-' + filterNom.replace(/[^a-zA-Z0-9]/g, '');
        if (filterSiren) filename += '_siren-' + filterSiren.replace(/[^a-zA-Z0-9]/g, '');
        if (filterCodeGeo) filename += '_code-' + filterCodeGeo.replace(/[^a-zA-Z0-9]/g, '');
        if (filterType) {
            const typeLabel = typesOrganismes.find(t => t.id == filterType)?.nom_categorie || filterType;
            filename += '_type-' + typeLabel.replace(/[^a-zA-Z0-9]/g, '');
        }
        filename += '_' + new Date().toISOString().split('T')[0] + '.csv';

        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        NotificationManager.success('CSV téléchargé');
    };

    const downloadXLSX = () => {
        const filteredData = getListeFiltered();
        const headers = ['Active', 'ID', 'Nom Organisme', 'SIREN', 'Code Géo', 'Type Organisme'];
        
        const getTypeLabel = (typeId) => {
            const type = typesOrganismes.find(t => t.id == typeId);
            return type ? type.nom_categorie : typeId;
        };
        
        const sheetData = [
            headers,
            ...filteredData.map(organisme => [
                organisme.active === 1 ? 'Oui' : 'Non',
                organisme.id,
                rescueHtml(organisme.nom),
                organisme.siren,
                organisme.code_geo,
                getTypeLabel(organisme.id_organisme_type)
            ])
        ];

        // Construire le nom du fichier avec les filtres
        let filename = 'organismes';
        if (filterNom) filename += '_nom-' + filterNom.replace(/[^a-zA-Z0-9]/g, '');
        if (filterSiren) filename += '_siren-' + filterSiren.replace(/[^a-zA-Z0-9]/g, '');
        if (filterCodeGeo) filename += '_code-' + filterCodeGeo.replace(/[^a-zA-Z0-9]/g, '');
        if (filterType) {
            const typeLabel = typesOrganismes.find(t => t.id == filterType)?.nom_categorie || filterType;
            filename += '_type-' + typeLabel.replace(/[^a-zA-Z0-9]/g, '');
        }
        filename += '_' + new Date().toISOString().split('T')[0] + '.xlsx';

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Organismes');
        
        XLSX.writeFile(workbook, filename);
        NotificationManager.success('XLSX téléchargé');
    };

    function compareIdAsc(a, b)
    {
        return a.id - b.id;
    }

    function compareIdDes(a, b)
    {
        return b.id - a.id;
    }

    function compareNomAsc(a, b)
    {
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
        
        if (nomA < nomB) return -1;
        if (nomA > nomB) return 1;
        return 0;
    }

    function compareNomDes(a, b)
    {
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
        
        if (nomA > nomB) return -1;
        if (nomA < nomB) return 1;
        return 0;
    }

    function compareSirenAsc(a, b)
    {
        return a.siren - b.siren;
    }

    function compareSirenDes(a, b)
    {
        return b.siren - a.siren;
    }

    function compareCodeGeoAsc(a, b)
    {
        const codeA = a.code_geo?a.code_geo.toUpperCase():0;
        const codeB = b.code_geo?b.code_geo.toUpperCase():0;
        
        if (codeA < codeB) return -1;
        if (codeA > codeB) return 1;
        return 0;
    }

    function compareCodeGeoDes(a, b)
    {
        const codeA = a.code_geo?a.code_geo.toUpperCase():0;
        const codeB = b.code_geo?b.code_geo.toUpperCase():0;
        
        if (codeA > codeB) return -1;
        if (codeA < codeB) return 1;
        return 0;
    }

    function compareTypeAsc(a, b)
    {
        return a.id_organisme_type - b.id_organisme_type;
    }

    function compareTypeDes(a, b)
    {
        return b.id_organisme_type - a.id_organisme_type;
    }

    function compareActiveAsc(a, b)
    {
        return a.active - b.active;
    }

    function compareActiveDes(a, b)
    {
        return b.active - a.active;
    }

	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />
            <ModalUpdateUser
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            user={userFocus}
            who={props.user?props.user.id:null}
            />

            <div style={{display: 'flex', margin: 25}}>
                <div style={{display: 'flex', flex: 1, alignItems: 'center'}}>
                    <p>Gestion \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Organismes</p>
                </div>
                <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
                    <p>Télécharger au format :</p>
                    <button 
                        onClick={downloadCSV}
                        style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ?'11px':'16px'}}
                    >
                        📥 CSV
                    </button>
                    <button 
                        onClick={downloadXLSX}
                        style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ?'11px':'16px'}}
                    >
                        📥 XLSX
                    </button>
                </div>
            </div>

            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50, padding: 20, backgroundColor: '#f9f9f9', marginBottom: 20}}>
                <h3 style={{marginTop: 0, marginBottom: 15}}>Filtres</h3>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 15}}>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '200px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Nom Organisme</label>
                        <input 
                            type="text" 
                            placeholder="Filtrer par nom..." 
                            value={filterNom}
                            onChange={(e) => setFilterNom(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        />
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>SIREN</label>
                        <input 
                            type="text" 
                            placeholder="Filtrer par SIREN..." 
                            value={filterSiren}
                            onChange={(e) => setFilterSiren(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        />
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Code Géo</label>
                        <input 
                            type="text" 
                            placeholder="Filtrer par code géo..." 
                            value={filterCodeGeo}
                            onChange={(e) => setFilterCodeGeo(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        />
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Type Organisme</label>
                        <select 
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        >
                            <option value="">Tous</option>
                            {typesOrganismes.map((type) => (
                                <option key={type.id} value={type.id}>{type.nom_categorie}</option>
                            ))}
                        </select>
                    </div>
                    <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Actif</label>
                        <select 
                            value={filterActive}
                            onChange={(e) => setFilterActive(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                        >
                            <option value="">Tous</option>
                            <option value="1">Actif</option>
                            <option value="0">Inactif</option>
                        </select>
                    </div>
                </div>
            </div>

            <div style={{margin: isMobile ? 10 : 50, padding: 15, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${blue}`, marginBottom: 20}}>
                <p style={{margin: 0, fontWeight: 'bold', color: '#333', fontSize: isMobile ? '12px' : '14px'}}>
                    {getListeFiltered().length} résultat{getListeFiltered().length > 1 ? 's' : ''} trouvé{getListeFiltered().length > 1 ? 's' : ''}
                </p>
            </div>

            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50}}>
                {isLoading ? (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px'}}>
                        <div style={{textAlign: 'center'}}>
                            <div style={{
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid ' + purple,
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 20px'
                            }}></div>
                            <p style={{color: purple, fontWeight: 'bold'}}>Chargement des organismes...</p>
                        </div>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                ) : (
                    <>
                <div style={{overflowX: 'auto'}}>
                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white', flexWrap: isMobile ? 'wrap' : 'nowrap', borderBottom: '3px solid ' + blue}}>
                        
                        <button
                        onClick={async () => {
                            if (boolActive) {
                                await liste.sort(compareActiveDes);
                            }
                            else {
                                await liste.sort(compareActiveAsc);
                            }
                            await setBoolActive(!boolActive);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 12%' : 0.08, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '35px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>Actif</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolID) {
                                await liste.sort(compareIdDes);
                            }
                            else {
                                await liste.sort(compareIdAsc);
                            }
                            await setBoolID(!boolID);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 12%' : 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '40px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>ID</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolNom) {
                                await liste.sort(compareNomDes);
                            }
                            else {
                                await liste.sort(compareNomAsc);
                            }
                            await setBoolNom(!boolNom);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? 1 : 0.4, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '150px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>{isMobile ? 'Nom' : 'Nom Organisme'}</p>
                        </button>
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolSiren) {
                                await liste.sort(compareSirenDes);
                            }
                            else {
                                await liste.sort(compareSirenAsc);
                            }
                            await setBoolSiren(!boolSiren);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: '12px 8px', fontSize: '14px', fontWeight: 'bold', minHeight: '45px', minWidth: '100px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>SIREN</p>
                        </button>
                        )}
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolCodeGeo) {
                                await liste.sort(compareCodeGeoDes);
                            }
                            else {
                                await liste.sort(compareCodeGeoAsc);
                            }
                            await setBoolCodeGeo(!boolCodeGeo);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: '12px 8px', fontSize: '14px', fontWeight: 'bold', minHeight: '45px', minWidth: '100px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>Code Géo</p>
                        </button>
                        )}
                        
                        <button
                        onClick={async () => {
                            if (boolType) {
                                await liste.sort(compareTypeDes);
                            }
                            else {
                                await liste.sort(compareTypeAsc);
                            }
                            await setBoolType(!boolType);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 20%' : 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', padding: isMobile ? '10px 4px' : '12px 8px', fontSize: isMobile ? '11px' : '14px', fontWeight: 'bold', minHeight: isMobile ? '40px' : '45px', minWidth: '80px', backgroundColor: blue, cursor: 'pointer', transition: 'all 0.2s'}}>
                            <p style={{margin: 0}}>{isMobile ? 'Type' : 'Type Org'}</p>
                        </button>
                    
                    </div>
                </div>

                <div style={{overflowY: 'auto', maxHeight: heightObject, backgroundColor: '#fafafa'}}>
                    {getListeFiltered().map((organisme, i) =>
                    <div key={i} style={{display: 'flex', flexWrap: isMobile ? 'wrap' : 'nowrap', width: '100%', borderBottom: '1px solid #e0e0e0', transition: 'all 0.2s', backgroundColor: i % 2 === 0 ? '#ffffff' : '#f5f5f5'}}>
                        <div style={{flex: isMobile ? '0 0 12%' : 0.08, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '35px', backgroundColor: 'transparent', borderLeft: '1px solid #ddd'}}>
                            <input 
                                type="checkbox"
                                checked={organisme.active === 1}
                                onChange={(e) => handleOrganismeChange(organisme.id, 'active', e.target.checked ? 1 : 0)}
                                style={{cursor: 'pointer', width: '18px', height: '18px'}}
                            />
                        </div>
                        <div style={{flex: isMobile ? '0 0 12%' : 0.1, display: 'flex', padding: isMobile ? '12px 6px' : '12px 8px', alignItems: 'center', justifyContent: 'center', minHeight: isMobile ? '45px' : '50px', minWidth: '40px', backgroundColor: 'transparent', fontWeight: 'bold', color: '#333', borderLeft: '1px solid #ddd'}}>
                            <p style={{margin: 0, fontSize: isMobile ? '11px' : '14px'}}>{organisme.id}</p>
                        </div>
                        <input 
                            type="text"
                            value={rescueHtml(organisme.nom)}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'nom', e.target.value)}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: isMobile ? 1 : 0.4, padding: isMobile ? '10px 6px' : '10px 8px', minHeight: isMobile ? '45px' : '50px', minWidth: '150px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: isMobile ? '10px' : '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        />
                        {!isMobile && (
                        <input 
                            type="text"
                            value={organisme.siren}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleOrganismeChange(organisme.id, 'siren', numericValue);
                            }}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: 0.2, padding: '10px 8px', textAlign: 'center', minHeight: '50px', minWidth: '100px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        />
                        )}
                        {!isMobile && (
                        <input 
                            type="text"
                            value={organisme.code_geo}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'code_geo', e.target.value)}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: 0.2, padding: '10px 8px', textAlign: 'center', minHeight: '50px', minWidth: '100px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        />
                        )}
                        {!isMobile && (
                        <select 
                            value={organisme.id_organisme_type}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'id_organisme_type', e.target.value)}
                            style={{flex: 0.2, padding: '10px 8px', textAlign: 'center', minHeight: '50px', minWidth: '100px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '14px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', cursor: 'pointer', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            {typesOrganismes.map((type) => (
                                <option key={type.id} value={type.id}>{type.nom_categorie}</option>
                            ))}
                        </select>
                        )}
                        {isMobile && (
                        <select 
                            value={organisme.id_organisme_type}
                            onChange={(e) => handleOrganismeChange(organisme.id, 'id_organisme_type', e.target.value)}
                            onBlur={() => saveOrganisme(organisme)}
                            style={{flex: '0 0 20%', padding: '10px 4px', textAlign: 'center', minHeight: '45px', minWidth: '80px', border: 'none', borderLeft: '1px solid #ddd', outline: 'none', fontSize: '11px', backgroundColor: 'transparent', transition: 'all 0.2s', boxSizing: 'border-box', cursor: 'pointer', color: '#333'}}
                            onFocus={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                            onBlurCapture={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            {typesOrganismes.map((type) => (
                                <option key={type.id} value={type.id}>{type.nom_categorie}</option>
                            ))}
                        </select>
                        )}
                    </div>
                    )}

                </div>

                    </>
                )}
            </div>

        </Access>
	);
}


export default Organismes;
